module.exports = __webpack_public_path__ + "static/user-list-items-dont-4d7778aef62be5994fe1d89e3f9bb98b.png";